module.exports = __webpack_public_path__ + "static/media/step-item-1.9846f38d.svg";